import styles from './FormFieldset.module.css';
import { classList } from '../../helpers/classList';
import { Checkbox } from '../Checkbox';

export interface FormFieldsetProps {
  title: string;
  className?: string;
  children?: any;
  checked?: boolean;
  onCheckedChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const FormFieldset = ({ className, title, children, checked, onCheckedChange }: FormFieldsetProps) => {
  return (
    <div className={classList(styles.fieldset, className)}>
      <div className={styles['title-container']}>
        {checked !== undefined && (
          <Checkbox
            className={styles.checkbox}
            labelClassName={styles.checkboxLabel}
            checked={checked}
            onChange={onCheckedChange}
            value={''}
            text={title}
          />
        )}
        {checked === undefined && <span className={styles.title}>{title}</span>}
      </div>
      <hr className={styles.hr} />
      <div className={classList('grid-content', styles.body)}>
        <div className='group-body'>{children}</div>
      </div>
    </div>
  );
};
